// extracted by mini-css-extract-plugin
export default {"FootPage":"FootPage_FootPage__4ZIhS","FootTag":"FootPage_FootTag__Qrs5s"};